<template>
	<div>
		<check-in-editor
			:employees="employees"
			:logged-in-employee="loggedInEmployee"
			:templates="templates"
			:isSaving="isSaving"
			@save="onSave"
			@cancel="onCancel"
		/>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import CheckInEditor from '@/components/checkin/CheckInEditor';

	export default {
		name: 'PageCheckInCreate',
		data() {
			return {
				isSaving: false
			}
		},
		components: {
			CheckInEditor
		},
		methods: {
			async onSave(checkIn) {

				this.isSaving = true;

				try {
					var result = await this.$store.dispatch('checkIns/add', checkIn);
					console.log('check in added: ' + checkIn);
					this.$router.push({name: 'checkIn', params: { id: result.id, justCreated: true } });
				} catch(err) {
					this.isSaving = false;
					console.error('Error saving check in');
					console.error(err);
				}
			},
			onCancel() {
				window.history.back();
			}
		},
		computed: {
			...mapGetters({
				employees: 'employees/employeesMiniActiveOnly',
				loggedInEmployee: 'loggedInEmployee',
				templates: 'checkIns/templates'
			}),
			templates() {
				return this.$store.getters['checkIns/checkInTemplates']; 
			},
		},
		created() {
			this.$store.dispatch('setPageTitle', 'New Check In');
		}
	};
</script>

<style></style>
